var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('ColumnList',{attrs:{"text":_vm.text,"categoryId":_vm.categoryId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }